import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {  MessageService, SelectItem } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { AppComponent } from '../../app.component';


@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss']
})
export class AppTopBarComponent implements OnInit{
  userName:string;
  gender:string;
  image:string;
  loading = false;
  _errorMessage:string=''; 
  get errorMessage():string
  {
    return this._errorMessage;
  }
  set errorMessage(value:string)
  {
   this._errorMessage = value;
   this.messageService.add({severity: 'error', summary: 'Error', detail:this._errorMessage, life: 2000});
  }
  flagEg: string = 'assets/layout/images/eg.png';
  flagEn: string = 'assets/layout/images/us.png';

  langs: SelectItem[];
  selectedLang: any;
  constructor(private translate: TranslateService,public app: AppComponent, public appMain: AppMainComponent,private httpHelper:HttphelperService,private router:Router,private messageService:MessageService) {
    this.langs = [
      { label: "English", value: "en"},
      { label: "العربيه", value: "ar" }
    ];
  }
  ngOnInit(): void {
    this.userName = localStorage.getItem('patientName');
    this.gender = localStorage.getItem('gender') == "1"? "Male" : "Female";
    this.image = localStorage.getItem('Image');
    let selectedLanguageCode = localStorage.getItem('lang');
    if(selectedLanguageCode != null)
    {
      this.selectedLang = selectedLanguageCode;
    }
  }
  signOut():void
  {
    this.loading = true;
    var url = "api/Account/SignOut";    
    this.httpHelper.getRequest(url,true).subscribe({
      next: res => {
            if(res.Success)
            {              
              localStorage.clear();
              this.router.navigate(['/login']);
            }
            else
            {
               this.errorMessage = res.Message;
            }
            this.loading = false;
         },
         error:err =>{ this.errorMessage = err; this.loading = false;}
    });
  }  
  changePassword():void
  {
    this.router.navigate(['/changepassword']);
  }
  changeLang(lang: any){
    let langId = 2;
    if(lang.value == "ar")
    {
      langId = 1;
    }
    this.loading = true;
    let urlLang = '/api/Account/UpdatePatientLanguage?id=' + langId;
    this.httpHelper.getRequest(urlLang,true).subscribe(response => {
      if(response.Success)
      {
         //this.translate.use(lang.value);
         localStorage.setItem('lang',lang.value);
         window.location.reload();
      }
      else
      {
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to update person language', life: 2000});
      }
      this.loading = false;
    },
    error=>{
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to connect to server', life: 2000});
      this.loading = false;
    })
  }
}
